/**
 * Parses a value into a Date object, handling multiple input formats.
 *
 * Supports Date objects, numeric timestamps, ISO strings, and epoch
 * millisecond strings (e.g., "1938409200000" from Google API responses).
 *
 * @param date - The value to parse (Date, number, string, or falsy)
 * @returns A valid Date or undefined if the input is falsy or unparseable
 */
export function parseDate(date?: unknown): Date | undefined {
  if (date && date instanceof Date) {
    return Number.isNaN(date.getTime()) ? undefined : date;
  }
  if (date && typeof date === 'number') {
    const parsed = new Date(date);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }
  if (date && typeof date === 'string') {
    // Handle numeric epoch timestamp strings (e.g., "1938409200000")
    if (/^\d+$/.test(date)) {
      const parsed = new Date(Number(date));
      return Number.isNaN(parsed.getTime()) ? undefined : parsed;
    }
    const parsed = new Date(date);
    return Number.isNaN(parsed.getTime()) ? undefined : parsed;
  }
  return undefined;
}
